/*
 * DAR FIGHT FIGHT DAYS — conditional visual hiding for EasySell's promo code.
 * Only use on the unpublished theme until tested on a real preview browser.
 * Preserves Shopify partner codes, customer fields, and checkout action.
 */
(function () {
  "use strict";
  var marker = "df-fight-days-easysell-code-field";
  var arabicCoupon = /(?:كود|رمز)\s*(?:التخفيض|الخصم)|(?:أدخل|ادخل)\s*(?:كود|رمز)/i;
  var englishCoupon = /discount.?code|coupon|promo.?code|reduction.?code|code.?promo/i;
  var buttonApply = /^(?:تطبيق|تفعيل|apply|apply code|valider|appliquer|utiliser)$/i;
  var nodeSelector = "input,textarea,select";
  var safeScope = "#easysell-modal, [id*='easysell' i], [class*='easysell' i], [id*='tyslo' i], [class*='tyslo' i], [id*='easy-sell' i]";

  function text(value) {
    return String(value == null ? "" : value).replace(/\s+/g, " ").trim();
  }
  function isCouponInput(el) {
    if (!el || !el.matches || !el.matches("input,textarea")) return false;
    if (el.closest("cart-discount-component,.cart-discount,cart-drawer")) return false;
    var hints = [
      el.getAttribute("placeholder"),
      el.getAttribute("aria-label"),
      el.getAttribute("name"),
      el.getAttribute("id"),
      el.getAttribute("data-testid")
    ].join(" ");
    return arabicCoupon.test(hints) || englishCoupon.test(hints);
  }
  function isApply(el) {
    if (!el || !el.matches || !el.matches("button,input[type='submit'],input[type='button']")) return false;
    return buttonApply.test(text(el.textContent || el.value || el.getAttribute("aria-label")));
  }
  function isCouponLabel(el) {
    if (!el || !el.matches || !el.matches("label,span,strong,p,h2,h3,h4,div")) return false;
    if (el.childElementCount > 2) return false;
    var val = text(el.textContent).replace(/[:：*]+$/g, "").trim();
    return /^(?:كود|رمز)\s*(?:التخفيض|الخصم)$/i.test(val) ||
      /^(?:discount.?code|code.?promo|promo.?code|coupon)$/i.test(val);
  }
  function inputCount(container) {
    return Array.from(container.querySelectorAll(nodeSelector)).filter(function (input) {
      return input.type !== "hidden";
    }).length;
  }
  function isEasySellCoupon(input) {
    if (input.closest(safeScope)) return true;
    // Some EasySell versions mount outside #easysell-modal.
    var form = input.closest("form");
    if (form) {
      var contents = text(form.textContent);
      if ((/رقم الهاتف|phone|telephone/i.test(contents) &&
           /المدينة|city|address|العنوان/i.test(contents)) ||
          /أكد الطلب الآن|تأكيد الطلب|الدفع عند الاستلام/i.test(contents)) return true;
    }
    var dialog = input.closest("[role='dialog'],dialog,[aria-modal='true']");
    if (dialog) {
      var body = text(dialog.textContent);
      if (/رقم الهاتف|المدينة|الحي|أكد الطلب الآن/i.test(body)) return true;
    }
    return false;
  }
  function labelIn(container) {
    return Array.from(container.querySelectorAll("label,span,strong,p,h2,h3,h4,div")).some(isCouponLabel);
  }
  function applyIn(container) {
    return Array.from(container.querySelectorAll("button,input[type='submit'],input[type='button']")).some(isApply);
  }
  function pickGroup(input) {
    var current = input.parentElement, fallback = null, depth = 0;
    while (current && depth++ < 11 && current !== document.body) {
      // Do not hide any parent that contains personal information fields.
      if (inputCount(current) > 1) break;
      if (applyIn(current)) {
        fallback = current;
        if (labelIn(current)) return current;
      }
      current = current.parentElement;
    }
    return fallback;
  }
  function isWithinScope(el, input) {
    var root = input.closest(safeScope) || input.closest("form") ||
      input.closest("[role='dialog'],dialog,[aria-modal='true']");
    return !!root && root.contains(el);
  }
  function closeLabel(input, group) {
    var scope = input.closest(safeScope) || input.closest("form") ||
      input.closest("[role='dialog'],dialog,[aria-modal='true']");
    if (!scope) return;
    var labels = Array.from(scope.querySelectorAll("label,span,strong,p,h2,h3,h4,div"));
    var rect = input.getBoundingClientRect(), best = null, nearest = Infinity;
    labels.forEach(function (node) {
      if (!isCouponLabel(node) || (group && group.contains(node))) return;
      var r = node.getBoundingClientRect();
      var distance = Math.abs(r.top - rect.top);
      if (distance < nearest && distance < 280) {
        nearest = distance;
        best = node;
      }
    });
    if (best) {
      var wrapper = best.parentElement;
      // Only collapse wrapper when it does not contain other form controls.
      if (wrapper && wrapper !== scope && !wrapper.querySelector(nodeSelector) &&
          !wrapper.querySelector("button")) wrapper.classList.add(marker);
      else best.classList.add(marker);
    }
  }
  function fallbackHide(input) {
    // Last resort: hide only coupon-specific controls, never customer fields.
    var rect = input.getBoundingClientRect();
    var scope = input.closest(safeScope) || input.closest("form") ||
      input.closest("[role='dialog'],dialog,[aria-modal='true']");
    if (!scope) return;
    var parent = input.parentElement;
    if (parent && inputCount(parent) === 1 &&
        !parent.querySelector("button")) parent.classList.add(marker);
    else input.classList.add(marker);
    var nearest = null, distance = Infinity;
    scope.querySelectorAll("button,input[type='submit'],input[type='button']").forEach(function (btn) {
      if (!isApply(btn)) return;
      var r = btn.getBoundingClientRect();
      var d = Math.abs(r.top - rect.top) + Math.abs(r.left - rect.left) * 0.1;
      if (d < distance) { distance = d; nearest = btn; }
    });
    if (nearest && distance < 320) nearest.classList.add(marker);
  }
  function update() {
    if (!document.documentElement.classList.contains("df-hide-discount-code")) return;
    document.querySelectorAll("input,textarea").forEach(function (input) {
      if (!isCouponInput(input) || !isEasySellCoupon(input)) return;
      var group = pickGroup(input);
      if (group) {
        // Locate the label while the input still has an on-screen rectangle.
        closeLabel(input, group);
        group.classList.add(marker);
      } else {
        closeLabel(input, null);
        fallbackHide(input);
      }
    });
  }
  function begin() {
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; update(); });
    }
    var observer = new MutationObserver(function (records) {
      if (document.documentElement.classList.contains("df-hide-discount-code") &&
          records.some(function (r) { return r.type === "childList" && r.addedNodes.length; })) {
        schedule();
      }
    });
    observer.observe(document.body,{childList:true,subtree:true});
    schedule();
    document.addEventListener("click",schedule,true);
    document.addEventListener("visibilitychange",schedule);
    window.addEventListener("pageshow",schedule);
    // Catch delayed React mounts or form re-renders inside app modal.
    window.setInterval(function () {
      if (document.documentElement.classList.contains("df-hide-discount-code")) schedule();
    },1500);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded",begin,{once:true});
  else begin();
})();